"use client";

export const DiscoverIdeasButton = () => (
  <button
    type="button"
    onClick={() => document.getElementById("nos-idees")?.scrollIntoView({ behavior: "smooth" })}
    className="flex h-12 cursor-pointer items-center justify-center rounded-lg border border-white/32 bg-white/24 px-6 text-base/5 font-semibold text-white backdrop-blur-[8px]"
  >
    Découvrir nos idées
  </button>
);
